import type { ComponentSchema } from '../../../../../schema-types'
import { schema as base } from '../product/product-detail.schema'

/**
 * Tanabana product page: the base fields plus the size chart in the summary card (merchant rich text), the
 * "Complete the look" rows under the photos and the delivery areas table. All optional; empty values hide their piece.
 */
export const schema: ComponentSchema = {
  ...base,
  commonFields: [
    ...base.commonFields,
    { key: 'sizeGuideTitle', label: 'Size chart title and link', type: 'string', default: 'Size chart' },
    { key: 'sizeGuide', label: 'Size guide', type: 'rich-text', help: 'Measurements table or fit notes, shown in the product card (a link beside the sizes jumps to it). Two tables, inches then centimetres, get Inch / CM tabs. Hidden while empty.' },
    { key: 'completeTheLookTitle', label: '"Complete the look" title', type: 'string', default: 'Complete the look', help: 'Up to three other products from the same category, shown under the photos with an Add to cart button.' },
    { key: 'showDeliveryAreas', label: 'Show delivery areas and charges', type: 'boolean', default: true },
  ],
}
